import React, { forwardRef } from "react";
import { Checkbox } from "@progress/kendo-react-inputs";

/**
 * DKNCheckbox — Daikin design system checkbox.
 * Wraps Kendo Checkbox.
 *
 * Props:
 *   checked    boolean — controlled state
 *   onChange   (e) => void  — e.value is boolean
 *   label      string
 *   indeterminate boolean — shows indeterminate state
 *   disabled   boolean
 *   error      string
 */
const DKNCheckbox = forwardRef(function DKNCheckbox(
  {
    checked,
    onChange,
    label,
    indeterminate = false,
    disabled = false,
    error,
    className = "",
    style,
    ...rest
  },
  ref
) {
  return (
    <div className={`dkn-checkbox-wrap ${className}`} style={style}>
      <Checkbox
        ref={ref}
        checked={checked}
        onChange={onChange}
        label={label}
        indeterminate={indeterminate}
        disabled={disabled}
        {...rest}
      />
      {error && <span className="dkn-input-helper-text">{error}</span>}
    </div>
  );
});

export default DKNCheckbox;
